import fetch from '@/utils/fetch';
import { getAdminMenu } from "@/router/permissjon";

export function login (query) {
  // 本地开发登录，店铺要关闭这个，只有平台总管理员才开启
  // query.logintype="localadmin";
  return fetch({
    url: '/operator/login',
    method: 'post',
    params: query
  })
}

export function getPermission (query) {
  let res = getAdminMenu();
  console.log('getAdminMenu===getPermission===', res);
  if (res) {
    return Promise.resolve(res);
  }
  return fetch({
    url: '/permission',
    method: 'get',
    params: query
  })
}

export function getUserInfo () {
  return fetch({
    url: '/operator/getinfo',
    method: 'get'
  })
}

export function refreshToken (params) {
  return fetch({
    url: '/token/refresh',
    method: 'get'
  })
}

export function getAgreementContent () {
  return fetch({
    url: '/espier/system/agreement',
    method: 'post'
  })
}
